
import { Page } from './page';
import { Constants } from './constants';
export class BookData {
    public Producer: String = "";
    public creator: String = "";
    public lastOpenedPage: any = 1;
    public type: String = "bookData";
    public _id: String = "";
    public owner: String = Constants.USER;
    public pages: Array<String> = new Array<String>();
    public bookDocId: String = '';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/bookData.ts